import React from 'react';
import { governmentPrograms, healthPlans } from '../data/insurance';

const PlanRow = ({ title, plans, variant = '' }) => (
  <div className="insurance-row">
    <h3 className="insurance-heading">{title}</h3>
    <ul className="insurance-chips">
      {plans.map((plan) => (
        <li key={plan.name} className={`insurance-chip ${variant}`.trim()}>{plan.name}</li>
      ))}
    </ul>
  </div>
);

const InsurancePlans = () => (
  <>
    <PlanRow title="Government programs" plans={governmentPrograms} variant="is-government" />
    <PlanRow title="Health plans" plans={healthPlans} />
  </>
);

export default InsurancePlans;
